import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ compact = false }) => {
  return (
    <Link to="/" className="inline-flex flex-col items-center group">
      <div className="flex items-center gap-2">
        <span
          className={`font-serif-display text-sq-navy leading-none ${
            compact ? "text-2xl" : "text-3xl md:text-4xl"
          }`}
        >
          Società <span className="text-sq-orange">Quotate</span>
        </span>
        <span className="text-sq-orange text-2xl leading-none">↗</span>
      </div>
      {!compact && (
        <span className="text-[11px] tracking-[0.25em] uppercase text-sq-orange mt-1">
          Gestioni e Bilanci in controluce
        </span>
      )}
    </Link>
  );
};

export default Logo;
